import msgboxVue from './index.vue'

// 定义插件对象

let MessageBox = {}

// vue的install方法，用于定义vue插件

MessageBox.install = function (Vue, options) {
  let currentMsg
  const MessageBoxInstance = Vue.extend(msgboxVue)

  const initInstance = () => {
    // 实例化vue实例
    currentMsg = new MessageBoxInstance()
    MessageBox = currentMsg
    MessageBox.currentMsg = currentMsg
    let msgBoxEl = currentMsg.$mount().$el
    document.body.appendChild(msgBoxEl)
  }

  // 在Vue的原型上添加实例方法，以全局调用

  Vue.prototype.$emsMsgBox =
    function (options) {
      if (!currentMsg) {
        initInstance()
      }

      if (typeof options === 'string') {
        currentMsg.content = options
      } else if (typeof options === 'object') {
        Object.assign(currentMsg, options)
      }

      return currentMsg.showMsgBox()
        .then(val => {
          currentMsg = null

          return Promise.resolve(val)
        })
        .catch(err => {
          currentMsg = null
          return Promise.reject(err)
        })
    }
}
MessageBox.close = function () {
  if (MessageBox.currentMsg) {
    let { currentMsg } = MessageBox
    currentMsg.colse()
  }
}

export default MessageBox
export { MessageBox }
